import { Platform, StyleSheet, View } from 'react-native';

import { IconStarRateFill, Skeleton, Text, tokens } from '@fhs/ui';

import { checkoutFocusableLabeledProps } from '../checkout-a11y';

interface EstimatedPointsEarnedProps {
  totalPointsEarned?: number;
  isLoading?: boolean;
}

export function EstimatedPointsEarned({ totalPointsEarned, isLoading }: EstimatedPointsEarnedProps) {
  const formattedPoints = totalPointsEarned?.toLocaleString();
  const pointsA11y = isLoading
    ? 'Estimated points earned, loading'
    : `Estimated points earned, ${formattedPoints} points`;

  return (
    <View style={styles.container} {...checkoutFocusableLabeledProps(pointsA11y)}>
      <Text.Paragraph size="sm" weight="semibold">
        Estimated Points Earned
      </Text.Paragraph>
      {isLoading ? (
        <Skeleton style={styles.skeleton} />
      ) : (
        <View style={styles.pointsContainer}>
          <View
            accessibilityElementsHidden
            importantForAccessibility="no-hide-descendants"
            {...(Platform.OS === 'web' ? { 'aria-hidden': true } : {})}
          >
            <IconStarRateFill size={16} color={tokens.colors.$houseYellow} />
          </View>
          <Text.Paragraph size="sm" weight="semibold">
            {formattedPoints}
          </Text.Paragraph>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pointsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
  },
  skeleton: {
    height: 16,
    width: 48,
    borderRadius: 4,
  },
});
